import React from 'react';

const WarningIcon = () =>  (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 6.45831V10.8333"
        stroke="#42389D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5667 7.15005V12.85C17.5667 13.7834 17.0667 14.6501 16.2584 15.1251L11.3084 17.9834C10.5 18.45 9.5 18.45 8.68333 17.9834L3.73333 15.1251C2.92499 14.6584 2.42499 13.7917 2.42499 12.85V7.15005C2.42499 6.21672 2.92499 5.35001 3.73333 4.87501L8.68333 2.01669C9.49166 1.55002 10.4917 1.55002 11.3084 2.01669L16.2584 4.87501C17.0667 5.35001 17.5667 6.20838 17.5667 7.15005Z"
        stroke="#42389D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 13.5V13.5833" stroke="#42389D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

export default WarningIcon;
